<template>
  <div class="first">
    <div class="logo"></div>
    <div class="age-limit-icon"></div>
    <div class="btn-group">
       <a href="https://nap.sohagame.vn/chanmenh" class="pay"></a>
       <a href="https://redeem.clicktouch.cc/wsy-vn/" class="cahnge"></a>
    </div>
    <div class="gd-wrapper">
      <div class="gd">
        <div :class="['fb-item', tw_status]" @click="getincommunityBytw"></div>
        <div :class="['fb-item', fb_status]" @click="getincommunityByfb"></div>
        <div
          :class="['gd-item', google_status]"
          @click="downloadByGoogle"
        ></div>
        <div :class="['gd-item', apple_status]" @click="downloadByApple"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import DatePicker from 'vue2-datepicker';
//  import 'vue2-datepicker/index.css';
export default {
  name: "first",
  data() {
    return {
      fb_status: "",
      tw_status: "",
      apple_status: "",
      google_status: ""
    };
  },
  methods: {
    async getBtnStatus() {
      const res = await this.APIS.getBtnStatus();
      if (!res.status) {
        const data = res.data;
        this.tw_status = "tw_" + data.twitter;
        this.fb_status = "fb_" + data.fb;
        this.apple_status = "apple_" + data.apple;
        this.google_status = "google_" + data.google;
      }
    },
    getincommunityBytw() {
      fbq("trackCustom", "GetincommunityBytw", {});
      if (this.tw_status.indexOf("disable") > -1) return;
      window.location.href = "https://www.facebook.com/groups/callmeemperorvn/";
    },
    getincommunityByfb() {
      fbq("trackCustom", "GetincommunityByfb", {});
      if (this.fb_status.indexOf("disable") > -1) return;
      window.location.href =
        "https://www.facebook.com/Ta-L%C3%A0-Ho%C3%A0ng-Th%C6%B0%E1%BB%A3ng-102525941617203";
    },
    downloadByGoogle() {
      fbq("trackCustom", "DownloadByGoogle", {});
      if (this.google_status.indexOf("disable") > -1) return;
      if (this.google_status.indexOf("appointment") > -1)
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.wsy.wansuiye.sohavn";
      if (this.google_status.indexOf("open") > -1) window.location.href = "";
    },
    downloadByApple() {
      fbq("trackCustom", "DownloadByApple", {});
      if (this.apple_status.indexOf("disable") > -1) return;
      if (this.apple_status.indexOf("appointment") > -1)
        window.location.href = "https://apps.apple.com/app/id6566179273";
      if (this.apple_status.indexOf("open") > -1) window.location.href = "";
    }
  },
  mounted() {
    this.getBtnStatus();
  }
};
</script>
<style scoped lang="less">
.first {
  position: relative;
  left: 0;
  right: 0;
  width: 100vw;
  height: 745px;
  background: url("../../assets/img/first/pc.jpg") no-repeat;
  background-size: 100%;

  .logo {
    top: 55px;
    left: 366px;
    position: absolute;
    // margin: 55px 0 0 366px;
    width: 197px;
    height: 85px;
    background: url("../../assets/img/first/LOGO.png") center no-repeat;
    background-size: 100%;
  }
  .age-limit-icon {
    top: 590px;
    left: 0;
    position: fixed;
    width: 155px;
    height: 122px;
    background: url("https://sohagame.vn/img/18.webp") center no-repeat;
    background-size: 100%;
    z-index: 100;
  }
  
  .btn-group{
     display: flex;
    align-items: center;
    justify-content: center;
    width: 440px;
    height: 60px;
    position: absolute;
    right: 120px;
    top: 40px;
    a{
      width: 244px;
      height: 60px;
      margin-left: 20px;
      &:nth-child(1){
        background: url('../../assets/img/first/pay.png') no-repeat;
        background-size: 100%;
      }
       &:nth-child(2){
        background: url('../../assets/img/first/change-enter.png') no-repeat;
        background-size: 100%;
      }
    }
  }
  .gd-wrapper {
    position: absolute;
    width: 1200px;
    left: 50%;
    margin: 0 0 0 -600px;
    height: 100px;
    bottom: 20px;

    .gd {
      .fb-item {
        float: left;
        margin: 20px 0 0 20px;
        width: 243px;
        height: 60px;
        border-radius: 34px;
        cursor: pointer;
      }

      .gd-item {
        float: left;
        margin: 20px 0 0 30px;
        width: 204px;
        height: 60px;
        cursor: pointer;
      }
    }
  }
}

.tw_disable {
  background: url("../../assets/img/first/tw_disabled.png") no-repeat;
  background-size: 100%;
}

.tw_open {
  background: url("../../assets/img/first/tw_open.png") no-repeat;
  background-size: 100%;
}

.fb_disable {
  background: url("../../assets/img/first/fb_disabled.png") no-repeat;
  background-size: 100%;
}

.fb_open {
  background: url("../../assets/img/first/fb_open.png") no-repeat;
  background-size: 100%;
}

.apple_disable {
  background: url("../../assets/img/first/apple_disabled.png") no-repeat;
  background-size: 100%;
}

.apple_appointment {
  background: url("../../assets/img/first/apple_appointment.png") no-repeat;
  background-size: 100%;
}

.apple_open {
  background: url("../../assets/img/first/apple_downlaod.png") no-repeat;
  background-size: 100%;
}

.google_disable {
  background: url("../../assets/img/first/google_disabled.png") no-repeat;
  background-size: 100%;
}

.google_appointment {
  background: url("../../assets/img/first/google_appointment.png") no-repeat;
  background-size: 100%;
}

.google_open {
  background: url("../../assets/img/first/google_downlaod.png") no-repeat;
  background-size: 100%;
}

@media screen and (min-width: 1281px) and (max-width: 1366px) {
  .first {
    height: 784px;
  }
}

@media screen and (min-width: 1367px) and (max-width: 1440px) {
  .first {
    height: 804px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 1500px) {
  .first {
    height: 852px;
  }
}

@media screen and (min-width: 1501px) and (max-width: 1550px) {
  .first {
    height: 877px;
  }
}

@media screen and (min-width: 1501px) and (max-width: 1620px) {
  .first {
    height: 909px;
  }
}

@media screen and (min-width: 1621px) and (max-width: 1740px) {
  .first {
    height: 972px;
  }
}

@media screen and (min-width: 1741px) and (max-width: 1840px) {
  .first {
    height: 1022px;
  }
}

@media screen and (min-width: 1841px) and (max-width: 1880px) {
  .first {
    height: 1052px;
  }
}

@media screen and (min-width: 1881px) and (max-width: 1920px) {
  .first {
    height: 1072px;
  }
}

@media screen and (min-width: 1921px) and (max-width: 1980px) {
  .first {
    height: 1090px;
  }
}

@media screen and (min-width: 1981px) {
  .first {
    height: 1160px;
  }
}

@media screen and (max-width: 640px) {
  .first {
    position: relative;
    left: 0;
    right: 0;
    width: 100vw;
    height: 11.25rem;
    background: url("../../assets/img/first/phone.jpg") no-repeat;
    background-size: 100% 100%;
    .age-limit-icon {
      top: 320px;
      width: 100px;
      height: 79px;
    }
    .logo {
      top: 0.24rem;
      left: 0.32rem;
      position: absolute;
      width: 1.97rem;
      height: 0.85rem;
      background: url("../../assets/img/first/LOGO.png") center no-repeat;
      background-size: 100%;
    }
     .btn-group{
     display: flex;
    align-items: center;
    justify-content: center;
    width: 4.40rem;
    height: 0.60rem;
    position: absolute;
    right: 0.12rem;
    top: 0.22rem;
    a{
      width: 2.2rem;
      height: 0.66rem;
      margin-left: 0.1rem;
      &:nth-child(1){
        background: url('../../assets/img/first/pay.png') no-repeat;
        background-size: 100%;
      }
       &:nth-child(2){
        background: url('../../assets/img/first/change-enter.png') no-repeat;
        background-size: 100%;
      }
    }
  }
    .gd-wrapper {
      position: absolute;
      width: 100vw;
      left: 0;
      margin: 0 auto;
      height: 2.06rem;
      bottom: 0;

      .gd {
        .fb-item {
          position: relative;
          float: left;
          height: 0.68rem;
          margin: 0.2rem 0 0 0.46rem;
          width: 2.7rem;
          left: 0.17rem;
          border-radius: 0.34rem;
          line-height: 0.68rem;
        }

        .gd-item {
          float: left;
          margin: 0.25rem 0 0 0.98rem;
          width: 2.04rem;
          height: 0.66rem;
        }
      }
    }
  }
}
</style>
